const MALE = 'male';
const FEMALE = 'female';
export default {
  MALE,
  FEMALE
};